export const emergencyContacts = [
  {
    title: "Crisis Text Line US",
    contacts: [
      { type: "Text:", icon: "textBubble", value: "HOME to 741741" },
      { type: "Website:", icon: "globe", value: "crisistextline.org" },
    ],
  },
  {
    title: "Suicide & Crisis Lifeline (US)",
    contacts: [
      { type: "Phone:", icon: "phone", value: "988" },
      {
        type: "Website:",
        icon: "globe",
        value: "988lifeline.org",
      },
    ],
  },
];

export const additionalResources = [
  [
    {
      title: "SAMHSA National Helpline",
      contacts: [
        { type: "Phone:", icon: "phone", value: "1-800-662-HELP (4357)" },
        {
          type: "Website:",
          icon: "globe",
          value: "samhsa.gov/find-help/helplines/national-helpline",
        },
      ],
    },
    {
      title: "Veteran Crisis Line",
      contacts: [
        { type: "Phone:", icon: "phone", value: "988 (Press 1)" },
        { type: "Text:", icon: "textBubble", value: "838255" },
        { type: "Website:", icon: "globe", value: "veteranscrisisline.net" },
      ],
    },
  ],
  [
    {
      title: "National Domestic Violence Hotline (US)",
      contacts: [
        { type: "Phone:", icon: "phone", value: "1-800-799-SAFE (7233)" },
        { type: "Text:", icon: "textBubble", value: "START to 88788" },
        { type: "Website:", icon: "globe", value: "thehotline.org" },
      ],
    },
    {
      title: "Trevor Project (LGBTQ+ Youth, US)",
      contacts: [
        { type: "Phone:", icon: "phone", value: "1-866-488-7386" },
        { type: "Text:", icon: "textBubble", value: "START to 678678" },
        { type: "Website:", icon: "globe", value: "thetrevorproject.org" },
      ],
    },
    {
      title: "RAINN (Sexual Assault Hotline)",
      contacts: [
        { type: "Phone:", icon: "phone", value: "1-800-656-4673" },
        { type: "Website:", icon: "globe", value: "online.rainn.org" },
      ],
    },
  ],
];

export const internationalResources = [
  {
    title: "International Association for Suicide Prevention (IASP)",
    contacts: [
      {
        type: "Website:",
        icon: "globe",
        value: "iasp.info/resources/Crisis_Centres",
      },
    ],
  },
  {
    title: "Befrienders Worldwide",
    contacts: [{ type: "Website:", icon: "globe", value: "befrienders.org" }],
  },
  {
    title: "Find a Helpline (Global Directory)",
    contacts: [{ type: "Website:", icon: "globe", value: "findahelpline.com" }],
  }
];
